import { Flex, Heading, Text } from '@backyard-ui/core';

import { type Review } from '@/infra/services/catalog/review/model';
import { RatingStars } from '@/presenters/components/common/RatingStars';

import { getRelativeTime } from './utils';

interface HeadProps extends Pick<Review, 'author' | 'date' | 'rating'> {}

function Head(props: HeadProps) {
  const { date, author = 'Anônimo', rating } = props;

  return (
    <Flex wrap="wrap" className="gap-3" direction="row" align="center">
      <div className="order-2 md:order-1">
        <RatingStars rating={rating} />
      </div>
      <div className="order-1 w-full md:order-2 md:w-auto">
        <Heading size="md" asChild>
          <span>{author}</span>
        </Heading>
      </div>
      <div className="order-3">
        <Text size="lg" color="gray-600" asChild>
          <span>{getRelativeTime(date)}</span>
        </Text>
      </div>
    </Flex>
  );
}

export default Head;
